import m from "mithril";
import i18n from "../../../shared/i18n/i18n";
import Component_Unit_Form_Editor from "./component_unit_form_editor";
import Component_Unit_Form_Settings from "./component_unit_form_settings";
import Unit_Courses from "../unit_courses";

let loading = false;
let tab = "editor";
let unit = null;

const Page_Unit_Form = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section with-menu", [
                        m("h1", i18n.t("form_unit")),
                        m(".toolbar-menu", [
                            m("div", {
                                class: tab === "editor" ? "active" : "", onclick: function () {
                                    tab = "editor";
                                }
                            }, i18n.t("editor")),
                            m("div", {
                                class: tab === "settings" ? "active" : "", onclick: function () {
                                    tab = "settings";
                                }
                            }, i18n.t("settings")),
                            m("div", {
                                class: tab === "courses" ? "active" : "", onclick: function () {
                                    tab = "courses";
                                }
                            }, i18n.t("courses"))
                        ])
                    ])
                ])
            ]),
            !loading ? [
                unit ? [
                    tab === "editor" ? m(Component_Unit_Form_Editor, {unit: unit})
                        : tab === "settings" ? m(Component_Unit_Form_Settings, {unit: unit.properties, onCoursesClick: function() { tab = "courses"; }})
                            : tab === "courses" ? m(Unit_Courses, {unitId: unit.properties.id})
                                : ""
                ] : m(".text-gray padding", i18n.t("invalid_unit"))
            ] : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")])
        ];
    }
};
export default Page_Unit_Form;
